/**
  * @file
  * Attach behaviors for the site menu.
  */

!((document, Drupal, $) => {
  'use strict';

  Drupal.behaviors.siteMenu = {

    attach: function (context) {
      const $heroImage = $('.header__hero', context);
      const $siteMenuBlock = $('.horizontal__links-menu', context);
      const $parent = $('#block-sitemenu', context);

      if ($heroImage.length > 0) {
        $siteMenuBlock.addClass('hero-image-present');
      }

      else {
        $parent.addClass('js-background');
      }
    }
  };
})(document, Drupal, jQuery);
